import moment from "moment";

export const getFormattedUsageData = (graphData,chooseViewDropdown) => {
    if (graphData && (graphData != "" || graphData != "No Records Available")) {
        let graphQuantity = [];
        let graphLabels = [];
        let noDataDaily=[];
        let noData = false;
        let graphAmount = [];
        try {
            graphData.forEach((item) => {
                graphQuantity.push(item.quantity);
                if(chooseViewDropdown?.dropDownCode=='USAGE_DROPDOWN_DAILY_VIEW'){
                    let name = item.usageDate!=""?moment(item.usageDate).format("Do MMM'YY"):item.intervalShortName;
                    graphLabels.push(name);
                }else{

                    graphLabels.push(item.intervalShortName);
                }
                graphAmount.push(item.amount)
                noDataDaily.push(item.noData);
            });
        } catch (err) {
          graphQuantity = [];
        }
        const filteredGraphQuantity = graphQuantity?.filter((item) => item != '0')
        filteredGraphQuantity?.length === 0 ? noData = true : noData = false
        return {graphQuantity, graphLabels, noDataDaily,graphAmount}
    }
    return;
}

export const getFormattedBillViewData = (billData, billDateRange, chartDateFormat) => {
    const filteredBillData = billData?.filter((value) => value.label === 'Bill');
    const datesArray = enumerateMonthsBetweenDates(billDateRange.startDate, billDateRange.endDate, chartDateFormat)
    const graphLabels = datesArray.map(item => item.mmm)
    const amountData = filteredBillData?.map((bill) => {        
        return {
            interval: moment(bill.date?.trim()).format('YYYY-MM'),
            amount: bill?.amount
        }
    })
    const graphQuantity = []
    let noData = false;
    datesArray.forEach((period) => {
        const billAmount = amountData?.find(amount => period?.yymm === amount?.interval)
        graphQuantity.push(billAmount?.amount ? billAmount?.amount : 0)
    })
    const filteredGraphQuantity = graphQuantity?.filter((item) => item != '0')
    filteredGraphQuantity?.length === 0 ? noData = true : noData = false;
    return {graphLabels, graphQuantity, noData}
}

const enumerateMonthsBetweenDates = (startDate, endDate, chartDateFormat) => {
    let date = []
    while(moment(startDate) <= moment(endDate)){
      date.push({yymm: moment(startDate?.trim()).format("YYYY-MM"), mmm: moment(startDate?.trim()).format(chartDateFormat)});
      startDate = moment(startDate?.trim()).add(1, 'months').format("YYYY-MM");
    }
    return date;
  }